import React, { Component } from 'react'

import ReactExport from "react-data-export";


import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Calendar, Badge, Button  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import moment from 'moment'
import Getteachet2 from './Getteachet2';
import Getprograme from './Getprograme';
import Modalpayedit from './Modalpayedit';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

moment.updateLocale('en', {
  weekdaysMin : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
});



//import {ExcelFile, ExcelSheet, ExcelColumn} from "react-export-excel";
//import Loadding from './Loadding';




export default class Reporttesscheckall2 extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          prenm:'',
          term:'',
          type:'',
          poname:'',
          typename:'ยังไม่ระบุ',
          Loadding:false,
         
        };
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.getListData = this.getListData.bind(this);
        this.dateCellRender = this.dateCellRender.bind(this);
        this.updateSearchtype = this.updateSearchtype.bind(this);
        this.getthschedule1 = this.getthschedule1.bind(this);
        this.exportpdf = this.exportpdf.bind(this);
      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
           setTimeout(() => {
             this.getthschedule1()
           }, 500);
    }


    getthschedule1() {
        this.setState({ Loadding: true})
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/reportgroupall/'+this.state.term+'/2')
           .then(res => {
            // console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           const stu_types = res.data.filter( ({ stu_type }) => stu_type === "2" );

             this.setState({ thschedule: stu_types})
             this.setState({ Loadding: false})
           }) 
         }, 0);
      }


  
      
    updateSearchtype(value) {
      // console.log(event.target.value)
      // const term = event.target.value;
      const type = value;
      this.setState({ type });
        //  setTimeout(() => {
        //    this.getthschedule()
        //  }, 500);
      if (type == 1) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร' });
      }
      if (type == 2) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร' });
      }
      if (type == 3) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร แม่สอด' });
      }
      if (type == 5) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร แม่สอด' });
      }

    }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedulesearch/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      getteachingschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/showteachingschedule/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ showteachingschedule: res.data})

             if (res.data.length !== 0) {
               const teacher = res.data[0].poname;
             //  const prenm = res.data[0].prenm;
               this.setState({ teacher });
             //  this.setState({ prenm });
             }
             
           }) 
         }, 0);
      }

   

      onChange(value) {
          console.log(`selected ${value}`);
          const idemp = value;
          this.setState({ idemp });


          const teachersearcha = this.state.thschedule.filter( ({ user_teacher }) => user_teacher === idemp );
          this.setState({ poname : teachersearcha[0].poname});
          this.setState({ prenm : teachersearcha[0].prenm});


          setTimeout(() => {
            this.getteachingschedule()
          }, 500);
     }


          onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          
           getListData(value) {
             let listData;
             this.state.showteachingschedule.map((showteachingschedule) => {
             // let daysum = Number(showteachingschedule.ss)
              //  for (let  index = 0; index < 5; index++) {
              //       daysum = daysum + 7;
              //       if (value.week() === daysum) {
              //        listData = [
              //               { type: 'warning', content: 'This is warning event.' },
              //               { type: 'success', content: 'This is usual event.' },
              //             ];
              //      }
              //  }

               if (value.weekdaysMin() === "Sun") {
                listData = [
                       { type: 'warning', content: 'This is warning event.' },
                       { type: 'success', content: 'This is usual event.' },
                     ];
               }
             
            //  <>{showteachingschedule.ss}  </>  
            return listData || [];
             });


            // let listData = this.state.showteachingschedule.map((showteachingschedule) =>
            
            // <li key={showteachingschedule.toString()}> {showteachingschedule.ss} </li>
            // );
           //  let  lissd = 'sds';
           //  let  lisd =  this.state.showteachingschedule.map((showteachingschedule) =>  <>{showteachingschedule.ss}  </>  );
          

         //console.log('dddd'+lissd);
        
     
          //   switch (value.date()) {
          
          //      case 5:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //       ];
          //       break;
          //     case 7:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //       ];
          //       break;
          //     case 10:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //         { type: 'error', content: 'This is error event.' },
          //       ];
          //       break;
          //     case 15:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event' },
          //         { type: 'success', content: 'This is very long usual event。。....' },
          //         { type: 'error', content: 'This is error event 1.' },
          //         { type: 'error', content: 'This is error event 2.' },
          //         { type: 'error', content: 'This is error event 3.' },
          //         { type: 'error', content: 'This is error event 4.' },
          //       ];
          //       break;
          //     default:
          //   }
             return listData || [];
           }


           dateCellRender(value) {
            const listData = this.getListData(value);
            return (
              <ul className="events">
                {listData.map(item => (
                  <li key={item.content}>
                    <Badge status={item.type} text={item.content} />
                  </li>
                ))}
              </ul>
            );
           }
          
           getMonthData(value) {
            if (value.month() === 8) {
              return 1394;
            }
           }
          
           monthCellRender(value) {
            const num = this.getMonthData(value);
            return num ? (
              <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
              </div>
            ) : null;
          }

          exportpdf = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
          //  console.log("dfdf")
                setTimeout(() => {
                   console.log(id)
                   window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+id, '_blank');
                 
                  
                 }, 1000); 

          }




    render() {

      console.log(this.state.type)
      console.log(this.state.term)
      

        const { Option } = Select;
        const online = window.navigator.onLine;
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )     
      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }
      


      //ปฏิทิน

const dataSet1 = [
    {
        name: "Johson",
        amount: 30000,
        sex: 'M',
        is_married: true
    },
    {
        name: "Monika",
        amount: 355000,
        sex: 'F',
        is_married: false
    },
    {
        name: "John",
        amount: 250000,
        sex: 'M',
        is_married: false
    },
    {
        name: "Josef",
        amount: 450500,
        sex: 'M',
        is_married: true
    }
];

const dataSet2 = [
    {
        name: "Johnson",
        total: 25,
        remainig: 16
    },
    {
        name: "Josef",
        total: 25,
        remainig: 7
    }
];



      const data = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'Curriculumopen_TEAM',
            sort: 'Curriculumopen_TEAM',
            width: 270
          },
        
          {
            label: 'จัดการ',
            field: 'Curriculumopen_Full_Name_EN',
            sort: 'Curriculumopen_Full_Name_EN',
            width: 100
          }


        ],

        rows: [...this.state.thschedule.map((data, i) => (
          {
             list: <>{i+1}</>,
             Curriculumopen_TEAM: <>{data.prenm}{data.poname}</>,
             Curriculumopen_Full_Name_EN: <> <MDBBtn color="unique" size="sm"  onClick={() => this.exportpdf(data.teacher_id1)}> <MDBIcon icon="print" /> พิมพ์</MDBBtn></>

          }
         ))]
        
    
    };

    const persons = <MDBDataTable
    // searching ={true}
     searchLabel="ค้นหา ชื่อ"
     striped
     bordered
     small 
     entries={20}
    // entriesOptions={["10", "20"]}
     order={["age", "desc"]}
     data={data}
     entriesLabel="จำนวนที่แสดง "
     infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
     paginationLabel={["ย้อนกลับ", "ถัดไป"]}
     responsive 
     sortRows={['random']}
     />


        return (
            <MDBContainer fluid>
              
    <Card type="inner"  title={<h4 className="unique-text"><MDBIcon icon="book" /> รายงานตรวจทั้งหมด ภาค กศ.บป กำแพง</h4>} >
    <MDBRow>
           
            <MDBCol sm="4">
              <p>เลือกภาคเรียน</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.term}
                            onSearch={this.onSearch} 
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564">1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                            <Option value="1/2565">1/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option value="2/2566">2/2566</Option>
                            <Option ative value="3/2566">3/2566</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option value="2/2567">2/2567</Option>
                            <Option ative value="3/2567">3/2567</Option>
                            <Option value="1/2568">1/2568</Option>
                            <Option value="2/2568">2/2568</Option>
                            <Option value="3/2568">3/2568</Option>
                            <Option value="1/2569">1/2569</Option>
                            <Option value="2/2569">2/2569</Option>
                            <Option value="3/2569">3/2569</Option>
                        </Select>
                    </div>
                    {/* <br/> */}

            </MDBCol>
            
            <MDBCol sm="8">
              {/* <p>เลือกประเภทนักศึกษา</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกประเภทนักศึกษา"
                            optionFilterProp="children"
                            onChange={this.updateSearchtype}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.type}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option value="1">ปกติกำแพงเพชร</Option>
                            <Option value="2">กศ.บป.กำแพงเพชร</Option>
                            <Option value="3">กศ.บป.กำแพงเพชร แม่สอด</Option>
                            <Option value="5">ปกติกำแพงเพชร แม่สอด</Option>
                           
                        </Select>
                    </div> */}
            </MDBCol>

  </MDBRow>

  {this.state.thschedule.length !== 0 ?<>
  <div className='text-right'>
                <ExcelFile filename={"รายงานกศบปเทอม "+this.state.term} element={ <MDBBtn size='sm'>EXPORT EXCEl</MDBBtn>}>
                 <ExcelSheet data={this.state.thschedule} name="รายงาน">
                    <ExcelColumn label="รหัสวิชา" value="SUBJCODE"/>
                    <ExcelColumn label="ชื่อวิชา" value="SUBJNAME"/>
                    <ExcelColumn label="หน่วยกิต" value="CRHR"/>
                    <ExcelColumn label="หมู่เรียน" value="id_major"/>
                    <ExcelColumn label="โปรแกรม" value="t_mjname"/>
                    <ExcelColumn label="กลุ่ม" value="group_id"/>
                    <ExcelColumn label="จำนวน" value="numregister"/>
                    <ExcelColumn label="ผู้สอนทั้งหมด"
                                 value={(col) => (col.nameth1 !== null ?(col.prenmth1)+''+(col.nameth1) : '' )+' '+( col.nameth2 !== null ? ','+(col.prenmth2)+''+(col.nameth2) : '' )+' '+( col.nameth3 !== null ? ','+(col.prenmth3)+''+(col.nameth3) : '' )+' '+( col.nameth4 !== null ? ','+(col.prenmth4)+''+(col.nameth4) : '' )+' '+( col.nameth5 !== null ? ','+(col.prenmth5)+''+(col.nameth5) : '' )+' '+( col.nameth6 !== null ? ','+(col.prenmth6)+''+(col.nameth6) : '' )+' '+( col.nameth7 !== null ? ','+(col.prenmth7)+''+(col.nameth7) : '' )+' '+( col.nameth8 !== null ? ','+(col.prenmth8)+''+(col.nameth8) : '' )+' '+( col.nameth9 !== null ? ','+(col.prenmth9)+''+(col.nameth9) : '' )+' '+( col.nameth10 !== null ? ','+(col.prenmth10)+''+(col.nameth10) : '' )      }/>
                     <ExcelColumn label="ผู้สอน1"
                     value={(col) => col.nameth1 !== null ? (col.prenmth1)+''+(col.nameth1):'' }/>
                    <ExcelColumn label="ผู้สอน2"
                     value={(col) => col.nameth2 !== null ? (col.prenmth2)+''+(col.nameth2):'' }/>
                    <ExcelColumn label="ผู้สอน3"
                     value={(col) => col.nameth3 !== null ? (col.prenmth3)+''+(col.nameth3):'' }/>
                    <ExcelColumn label="ผู้สอน4" 
                     value={(col) => col.nameth4 !== null ? (col.prenmth4)+''+(col.nameth4):'' }/>
                    <ExcelColumn label="ผู้สอน5" 
                     value={(col) => col.nameth5 !== null ? (col.prenmth5)+''+(col.nameth5):'' }/>
                    <ExcelColumn label="ผู้สอน6" 
                     value={(col) => col.nameth6 !== null ? (col.prenmth6)+''+(col.nameth6):'' }/>
                    <ExcelColumn label="ผู้สอน7" 
                     value={(col) => col.nameth7 !== null ? (col.prenmth7)+''+(col.nameth7):'' }/> 
                    <ExcelColumn label="ผู้สอน8" 
                     value={(col) => col.nameth8 !== null ? (col.prenmth8)+''+(col.nameth8):'' }/>
                    <ExcelColumn label="ผู้สอน9" 
                     value={(col) => col.nameth9 !== null ? (col.prenmth9)+''+(col.nameth9):'' }/>
                    <ExcelColumn label="ผู้สอน10" 
                     value={(col) => col.nameth10 !== null ? (col.prenmth10)+''+(col.nameth10):'' }/>
                    <ExcelColumn label="วัน" value="ss"/>
                    <ExcelColumn label="วัน" value="nameday"/>
                    <ExcelColumn label="เวลา"
                                 value={(col) => col.day === 'weekly1' ? (col.times1+' - '+col.timesend1) : col.day === 'weekly2' ? (col.times2+' - '+col.timesend2): (col.times3+' - '+col.timesend3) }/>
                    {/* <ExcelColumn label="เวลา" value={(col)=>(col.times1+' - '+col.timesend1)} />  */}
                    <ExcelColumn label="ห้องเรียน"
                                 value={(col) => col.day === 'weekly1' ? (col.classroom1) : col.day === 'weekly2' ? (col.classroom2): (col.classroom3) }/>
                    {/* <ExcelColumn label="ห้องเรียน" value="classroom1"/> */}
                    {/* <ExcelColumn label="Marital Status"
                                 value={(col) => col.is_married ? "Married" : "Single"}/> */}

                </ExcelSheet>


                {/* <ExcelSheet data={dataSet2} name="Leaves">
                    <ExcelColumn label="Name" value="name"/>
                    <ExcelColumn label="Total Leaves" value="total"/>
                    <ExcelColumn label="Remaining Leaves" value="remaining"/>
                </ExcelSheet> */}
            </ExcelFile>
   </div>         
  </>:<></>}

          

{/* {persons} */}
<br/>

     {this.state.Loadding === true ?<>
     <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
     </>:<>
     
 
      

                        <MDBTable  bordered small responsive>
                                <MDBTableHead color="grey lighten-1">
                                <tr>
                                    <th  className="text-center">ลำดับ</th>
                                    <th  className="text-center">รหัสวิชา</th>
                                    <th  className="text-center">ชื่อวิชา</th>
                                    <th  className="text-center">หน่วยกิต</th>
                                    <th  className="text-center">หมู่เรียน</th>
                                    <th  className="text-center">โปรแกรม</th>
                                    <th  className="text-center">จำนวน</th>
                                    <th  className="text-center">ผู้สอน</th>
                                
                                    {/* <th  className="text-center">กลุ่ม</th> */}
                                    <th  className="text-center">วัน</th>
                                    <th  className="text-center">เวลา</th>
                                    <th  className="text-center">ห้องเรียน</th>
                                </tr>
                            
                                </MDBTableHead>
                                <MDBTableBody>
                                {this.state.thschedule.map((showteachingschedule,index) => {
                                
                                //กศบป
                                    const  time2 = Number (showteachingschedule.hour1*55)
                                    const  ddf = time2-5
                                    const  now = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                                    const totalsss = now.setMinutes(now.getMinutes()+ddf);
                                    const wanwela = new Date(totalsss)
                                    const wanwela1 =  wanwela.toLocaleTimeString()

                                    //ปกติ
                                    const  timenormal = Number (showteachingschedule.hour1*60)
                                    const  now2 = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                                    const totalsss2 = now2.setMinutes(now2.getMinutes()+timenormal);
                                    const wanwela2 = new Date(totalsss2)
                                    const normal =  wanwela2.toLocaleTimeString()
                                    
                                    return   <tr>
                                        <td>{index+1}</td>
                                        <td>{showteachingschedule.SUBJCODE}</td>
                                        <td>{showteachingschedule.SUBJNAME}</td>
                                        <td>{showteachingschedule.CRHR}</td>
                                        <td>{showteachingschedule.id_major} </td>
                                        {/* <td>{showteachingschedule.major} <Getprograme id_major = {showteachingschedule.id_major} /></td> */}
                                        <td>{showteachingschedule.t_mjname}
                                            {/* {showteachingschedule.id_major !== null ?<><Getprograme id_major = {showteachingschedule.id_major} /></>:<></>} */}
                                            </td>
                                        <td>{showteachingschedule.numregister}</td>
                                        <td>
                                        {showteachingschedule.prenmth1}{showteachingschedule.nameth1}  
                                        {showteachingschedule.nameth2 !== null ? <>, {showteachingschedule.prenmth2}{showteachingschedule.nameth2}</> : <></>} 
                                        {showteachingschedule.nameth3 !== null ? <>, {showteachingschedule.prenmth3}{showteachingschedule.nameth3}</> : <></>} 
                                        {showteachingschedule.nameth4 !== null ? <>, {showteachingschedule.prenmth4}{showteachingschedule.nameth4}</> : <></>} 
                                        {showteachingschedule.nameth5 !== null ? <>, {showteachingschedule.prenmth5}{showteachingschedule.nameth5}</> : <></>} 
                                        {showteachingschedule.nameth6 !== null ? <>, {showteachingschedule.prenmth6}{showteachingschedule.nameth6}</> : <></>} 
                                        {showteachingschedule.nameth7 !== null ? <>, {showteachingschedule.prenmth7}{showteachingschedule.nameth7}</> : <></>} 
                                        {showteachingschedule.nameth8 !== null ? <>, {showteachingschedule.prenmth8}{showteachingschedule.nameth8}</> : <></>} 
                                            {/* {showteachingschedule.prenm}{showteachingschedule.poname} 
                                            {showteachingschedule.teacher_id2 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id2}  /> </>:<></>}
                                        {showteachingschedule.teacher_id3 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id3}  /> </>:<></>}
                                        {showteachingschedule.teacher_id4 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id4}  /> </>:<></>}
                                        {showteachingschedule.teacher_id5 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id5}  /> </>:<></>}
                                        {showteachingschedule.teacher_id6 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id6}  /> </>:<></>}
                                        {showteachingschedule.teacher_id7 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id7}  /> </>:<></>}
                                        {showteachingschedule.teacher_id8 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id8}  /> </>:<></>}
                                        {showteachingschedule.teacher_id9 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id9}  /> </>:<></>}
                                        {showteachingschedule.teacher_id10 !== null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id10}  /> </>:<></>} */}
                                        </td>
                                        
                                        {/* <td> <p><Modalcolor idcolor={teachingschedule.group_id} /></p></td> */}
                                        {/* <td>อาจารย์{teachingschedule.poname}</td>Getteachet2 */}

                                    {/* ช่วงที่1 */}
                                        <td> {showteachingschedule.ss === '1' ?<> จันทร์</>:<></> }
                                            {showteachingschedule.ss === '2' ?<> อังคาร</>:<></> }
                                            {showteachingschedule.ss === '3' ?<> พุธ</>:<></> }
                                            {showteachingschedule.ss === '4' ?<> พฤหัสบดี</>:<></> }
                                            {showteachingschedule.ss === '5' ?<> ศุกร์</>:<></> }
                                            {showteachingschedule.ss === '6' ?<> เสาร์</>:<></> }
                                            {showteachingschedule.ss === '7' ?<> อาทิตย์</>:<></> }
                                            {showteachingschedule.ss === '8' ?<> ----</>:<></> }
                                        </td>
                                        <td>
                                        {showteachingschedule.ss === '8' ?<> ----</>:<>
                                                    {showteachingschedule.times1 === null || showteachingschedule.times1 === ''  ? <></> :<>
                                                        {showteachingschedule.day === 'weekly2' ?<>{showteachingschedule.times2} - {showteachingschedule.timesend2}</>:<>{showteachingschedule.day === 'weekly3' ?<>{showteachingschedule.times3} - {showteachingschedule.timesend3}</>:<>{showteachingschedule.times1} - {showteachingschedule.timesend1}</>}</>}
                                                    </> }
                                           </> }
                                        </td>
                                        <td > 
                                        {showteachingschedule.ss === '8' ?<> ----</>:<>
                                         {showteachingschedule.day === 'weekly2' ?<>{showteachingschedule.classroom2}</>:<>{showteachingschedule.day === 'weekly3' ?<>{showteachingschedule.classroom3}</>:<>{showteachingschedule.classroom1}</>}</>}
                                        </> }
                                             
                                        </td>
                                        </tr>
                                })}   
                                </MDBTableBody>
                            </MDBTable>
            </>}

        </Card>
        {/* <Calendar dateCellRender={this.dateCellRender} monthCellRender={this.monthCellRender} />, */}
            </MDBContainer>

        )
    }
}
